import request from '@/utils/request';

const PATH = '/reservation-type';

export const getReservationTypeList = () => request({
  url: PATH,
  method: 'get',
});
